import React, { useEffect, useRef } from "react";
import "./PartnershipModal.css";

const NEXT_STEPS = [
    "Our partnerships team reviews your inquiry.",
    "We reach out using your preferred method of contact.",
    "Together we explore how MYREDFOLDER® fits your goals.",
];

// Shown inside the inquiry popups after a successful submit.
export default function FormSuccess({ message, onClose }) {
    const closeRef = useRef(null);

    // Move focus to the primary action so keyboard / screen-reader users land on the confirmation.
    useEffect(() => {
        if (closeRef.current) closeRef.current.focus();
    }, []);

    return (
        <div className="mrf-success" role="dialog" aria-modal="true" aria-labelledby="mrf-success-title">
            <button type="button" className="mrf-modal__close" aria-label="Close" onClick={onClose}>&times;</button>
            <span className="mrf-success__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="44" height="44" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                    <path className="mrf-success__check" d="M5 12.5l4.5 4.5L19 7.5" />
                </svg>
            </span>
            <h2 id="mrf-success-title" className="mrf-success__title">Inquiry received</h2>
            <p className="mrf-success__text">{message}</p>

            <div className="mrf-success__next">
                <p className="mrf-success__next-title">What happens next</p>
                <ol className="mrf-success__steps">
                    {NEXT_STEPS.map((step) => (
                        <li key={step}>{step}</li>
                    ))}
                </ol>
            </div>

            <button ref={closeRef} type="button" className="mrf-btn mrf-btn--primary" onClick={onClose}>Done</button>
        </div>
    );
}
